module.exports = __webpack_public_path__ + "static/media/20A.d64c6892.jpg";